<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editar="editar($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar($event)"
      :cols="columnas"
    ></tablita>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "id",
        label: "Id",
        busqueda: "",
        tipo: "number",
        searchable: false,
        path: "id",
      },
      {
        key: "nombre",
        label: "Nombre",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "nombre",
      },
      {
        key: "tipo_dato",
        label: "Tipo Dato",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "tipo_dato_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "texto",
      },
      {
        key: "unidad_medida",
        label: "Unidad de Medida",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "unidad_medida_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "abreviacion",
      },
      {
        key: "activo",
        label: "Activo",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "activo_texto",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      { cols: 6, tipo: "texto", key: "nombre", valor: "", label: "Nombre (*)" },
      {
        cols: 6,
        tipo: "select",
        key: "tipo_dato",
        valor: "",
        label: "Tipo Dato (*)",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "texto",
      },
      {
        cols: 6,
        tipo: "select",
        key: "unidad_medida",
        valor: "",
        label: "Unidad de Medida",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "abreviacion",
      },
      {
        cols: 6,
        tipo: "checkbox",
        key: "activo",
        valor: true,
        label: "Activo",
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Parametro",
      ancho: "xl",
      ruta: "/lab_parametros",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Parámetros",
      titulo_boton: "Crear Parámetro",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    tipo_datos: [],
    unidad_medidas: [],
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.cargar_tipo_datos();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_tipo_datos() {
      await this.axios
        .get(`${this.api}/parametros/tipo_datos`, this.cabeceras_json)
        .then((res) => {
          this.tipo_datos = res.data.data;
          this.inputs[1].opciones = this.tipo_datos;
          this.columnas[2].opciones = this.tipo_datos;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_unidad_medidas();
    },
    async cargar_unidad_medidas() {
      await this.axios
        .get(`${this.api}/parametros/unidad_medidas`, this.cabeceras_json)
        .then((res) => {
          this.unidad_medidas = res.data.data;
          this.inputs[2].opciones = this.unidad_medidas;
          this.columnas[3].opciones = this.unidad_medidas;
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.cargar("");
      this.$emit("cargar");
    },

    async cargar($event) {
      this.pagina_actual = `${this.api}/lab_parametros${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/lab_parametros${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
    },
    async cargar_url(url) {
      if (url) {
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/lab_parametros`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/lab_parametros/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>